import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import FooterEN from "../EN/footer/FooterEN";
import Footer from "../footer/Footer";

const FooterWrapper = () => {
  const location = useLocation();
  const [isEnglish, setIsEnglish] = useState(null);
  useEffect(() => {
    if (window.location.href.indexOf("/en") >= 0) {
      setIsEnglish(true);
    } else {
      setIsEnglish(false);
    }
  }, [location]);

  return (
    <div id="footer">
      {isEnglish === false ? (
        <Footer />
      ) : isEnglish === true ? (
        <FooterEN />
      ) : null}
    </div>
  );
};

export default FooterWrapper;
